export const URL_PARAMS = {
  BRAND_ALERT: "brand_alert",
  GROUP_LISTINGS_ENABLED: "group_listings_enabled"
};
